module.exports = __webpack_public_path__ + "static/media/gq.6667d838.svg";